import Image from "next/image";
import Link from "next/link";
import { Podcast, Youtube } from "lucide-react";

interface PopularPodcastItemProps {
  podcast: {
    name: string;
    ownerAvatarUrl?: string;
    author?: string;
    defaultLevelRange?: string[];
    slug?: string;
  };
  href?: string;
  type?: 'podcast' | 'channel';
}

export default function PopularPodcastItem({ podcast, href, type }: PopularPodcastItemProps) {
  const levelRange = Array.isArray(podcast.defaultLevelRange)
    ? podcast.defaultLevelRange.map(item => String(item).trim()).filter(Boolean)
    : [];
  const levelRangeText = levelRange.join(" - ");

  const displayNameSource =
    typeof podcast.name === "string" && podcast.name.trim().length > 0
      ? podcast.name
      : typeof podcast.author === "string" && podcast.author.trim().length > 0
        ? podcast.author
        : "Channel";
  const displayName = displayNameSource.trim();
  const formattedName = podcast.slug
    ? podcast.slug
    : displayName.includes(' ')
      ? displayName.replace(/\s+/g, '_')
      : displayName;

  const avatarUrl = podcast.ownerAvatarUrl || "/logo.svg";
  
  const linkHref = href || `/channels/${encodeURIComponent(formattedName)}`;

  return (
    <Link href={linkHref} className="block group">
      <div className="flex flex-col items-center text-center w-20 transition-transform duration-300 group-hover:scale-105">
        <div className="relative w-20 h-20 mb-1">
          <div className="w-full h-full rounded-full overflow-hidden border-2 border-primary/10 shadow-sm">
            <Image
              src={avatarUrl}
              alt={displayName}
              width={96}
              height={96}
              className="object-cover group-hover:brightness-110 transition-all duration-300"
            />
          </div>
          
          {type && (
            <div className="absolute bottom-1 right-1 z-10">
              {type === 'podcast' ? (
                <div className="bg-amber-500 text-white rounded-md p-1 shadow-sm bg-opacity-90">
                  <Podcast className="w-3 h-3" />
                </div>
              ) : (
                <div className="bg-red-600 text-white rounded-md p-1 shadow-sm bg-opacity-90">
                  <Youtube className="w-3 h-3" />
                </div>
              )}
            </div>
          )}
        </div>
        {/* {levelRangeText && (
          <p className="text-[10px] text-muted-foreground">
            {levelRangeText}
          </p>
        )} */}
        <h3 className="text-xs font-medium line-clamp-2 transition-colors duration-200 group-hover:text-primary">
          {displayName}
        </h3>
      </div>
    </Link>
  );
}
